import classNames from "classnames";
import React from "react";
import { LineClamp } from "@lux/atoms/components/LineClamp";

export const InformationRow = ({
  icon,
  className,
  title,
  subtitle,
  subtitleClassName,
  value,
  subValue,
  onClick,
}: {
  icon: React.ReactNode;
  title: React.ReactNode | string;
  subtitle: React.ReactNode | string;
  subtitleClassName?: string | null;
  value: React.ReactNode;
  subValue: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <div
      className={classNames(
        "information-row",
        {
          "animated clickable": Boolean(onClick),
        },
        className,
      )}
      onClick={onClick}
    >
      <div className="icon flex-center-center">{icon}</div>

      <div className="flex-1 flex-center spread">
        <div className="flex-column flex-1 spread pr-2">
          <div className="title fw-medium">
            <LineClamp
              text={title}
              lines={1}
              style={{ wordBreak: "break-all" }}
            />
          </div>

          <div className={classNames("fs-sm text-tertiary", subtitleClassName)}>
            <LineClamp
              text={subtitle}
              lines={1}
              // TODO: why do we need break-all here?
              style={{ wordBreak: "break-all" }}
            />
          </div>
        </div>

        <div className="value-column flex-column spread">
          <div className="value">{value}</div>

          {subValue ? (
            <div className="flex">{subValue}</div>
          ) : (
            <div className="flex-1" />
          )}
        </div>
      </div>

      <style jsx>{`
        .information-row {
          display: flex;
          align-items: stretch;

          .icon {
            margin-right: 0.75rem;
          }

          &.clickable {
            cursor: pointer;

            &:hover {
              background-color: var(--hover-bg-color);
            }
          }

          .title :global(code) {
            font-size: var(--font-size-regular);
          }

          .value-column {
            height: 100%;
            align-items: flex-end;
          }
        }
      `}</style>
    </div>
  );
};
